<template>
  <v-container v-if="show" fluid class="pa-0">
    <!-- Title -->
    <v-features-title />
    <!-- Attributes -->
    <v-features-list />
    <!-- Message if there is no features -->
    <v-features-messages />
    <!-- Action buttons -->
    <v-features-action-buttons />
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

import VFeaturesActionButtons from "./FeaturesActionButtons.vue";
import VFeaturesList from "./FeaturesList";
import VFeaturesMessages from "./FeaturesMessages";
import VFeaturesTitle from "./FeaturesTitle";

export default {
  components: {
    VFeaturesActionButtons,
    VFeaturesList,
    VFeaturesMessages,
    VFeaturesTitle
  },
  computed: {
    ...mapState("ner", {
      classification: state => state.classification
    }),
    /**
     * Show this component only if there is a selected classification.
     */
    show() {
      return !!this.$store.state.ner.classification;
    }
  },
  watch: {
    /**
     * Watch the classification to get its features.
     */
    classification() {
      if (this.classification) this.getFeatures();
    }
  },
  methods: {
    ...mapActions("ner", ["getFeatures"])
  }
};
</script>